import React from 'react';
import { useDispatch } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
    Text,
    StyledCard,
    StyledCardContent,
    Avatar,
    FilledIconButton,
    MessagesIcon,
    NoticeIcon,
} from '../../index';

import { setMessagesReceiver, alertError, alertSuccess } from '../../../redux/stateActions';

import { sendNotificationSession } from '../../../services/provider';

export const MemberCard = ({ data, meetData, maxHeight, disabled, sendNoti }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const handleClickPatientDetail = (id) => {
        history.push(`/provider/session/client/detail/${id}`);
    };

    const handleClickMessages = (patient) => {
        dispatch(
            setMessagesReceiver({
                id: patient.id,
                avatar: patient?.user?.avatar?.url,
                name: patient?.user?.fullname,
                isGroup: false,
            })
        );
    };

    const handleSendNotification = async (patient) => {
        const foundSummary = meetData.sessions[0].patient_summaries.find(
            (summary) => summary.patient.id === patient.id
        );

        try {
            const res = await sendNotificationSession({ patientSummaryID: foundSummary.id });

            if (res.status === 200) {
                dispatch(alertSuccess('Notification sent'));
            } else {
                throw new Error(res);
            }
        } catch (error) {
            dispatch(alertError(`Cannot send notification: ${error}`));
        }
    };

    return (
        <StyledCard padding="20px">
            <StyledCardContent>
                <Text $fontSize="18px" $bold>
                    Member
                </Text>
                <div
                    style={{
                        marginTop: '15px',
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '5px',
                        maxHeight: `${maxHeight - 82}px`,
                        overflowY: 'auto',
                    }}
                >
                    {data.map((item) => (
                        <StyledCard
                            padding="8px 12px"
                            $borderColor="gray6"
                            key={'MemberCard' + item.id}
                            style={{ minHeight: '75px' }}
                        >
                            <StyledCardContent>
                                <div style={{ display: 'flex' }}>
                                    <Avatar
                                        alt={!item?.user ? '' : item?.user?.fullname}
                                        src={!item?.user ? null : item?.user?.avatar?.url}
                                        $avatarSize="56px"
                                        onClick={() => handleClickPatientDetail(item.id)}
                                        disabled={!item?.user}
                                    />

                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginLeft: '8px',
                                            width: '100%',
                                        }}
                                    >
                                        <Text
                                            style={{ margin: '4px 0 8px', maxWidth: '200px' }}
                                            $fontSize="16px"
                                            $ellipsis
                                            $lineHeight="20px"
                                            $bold
                                            onClick={() => handleClickPatientDetail(item.id)}
                                            disabled={!item?.user}
                                        >
                                            {!item?.user ? 'Inactive' : item?.user?.fullname}
                                        </Text>
                                    </div>

                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginLeft: '10px',
                                        }}
                                    >
                                        <FilledIconButton
                                            $backgroundColor="blue2"
                                            onClick={() => handleClickMessages(item)}
                                            disabled={!item?.user}
                                        >
                                            <MessagesIcon />
                                        </FilledIconButton>

                                        {sendNoti && (
                                            <Tooltip
                                                title={
                                                    <div style={{ padding: '5px 12px' }}>
                                                        <Text $fontSize="16px" $color="gray4">
                                                            Send notification
                                                        </Text>
                                                    </div>
                                                }
                                                arrow
                                                placement="top"
                                                disableHoverListener={disabled}
                                            >
                                                <div>
                                                    <FilledIconButton
                                                        $icon
                                                        $backgroundColor="purple"
                                                        onClick={() => handleSendNotification(item)}
                                                        disabled={!item?.user || disabled}
                                                    >
                                                        <NoticeIcon />
                                                    </FilledIconButton>
                                                </div>
                                            </Tooltip>
                                        )}
                                    </div>
                                </div>
                            </StyledCardContent>
                        </StyledCard>
                    ))}
                </div>
            </StyledCardContent>
        </StyledCard>
    );
};

MemberCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    meetData: PropTypes.object,
    disabled: PropTypes.bool,
    maxHeight: PropTypes.number,
};
